// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","532":"60472bb95f94d4066369f32717bcf041bda24f6f"}[chunkId] + "-" + {"245":"72391b602e049626aa42","453":"af2d38cac9795f956df1","532":"e33332bf0e6c6f14a6d4"}[chunkId] + ".js";
};